import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/pt-br';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import style from './ComponenteCalendario.module.css';
import EventoApi from '../../services/EventoApi';
import TurmaApi from '../../services/TurmaApi';
import PessoaTurmaApi from '../../services/PessoaTurmaApi';
import Searchbar from '../searchBar/Searchbar';
import BotaoNovo from '../botaoNovo/BotaoNovo';
import { Button, Form, Modal } from 'react-bootstrap';
import Select from 'react-select';
import Alerta from '../alerta/Alerta';
import ValidarPermissao from '../../services/ValidarPermissao';
import BotaoComLoading from "../../components/loadingBotoes/LoadingBotoes";
import Loader from '../loader/Loader';
import InputBuscar from '../inputBuscar/InputBuscar';
moment.locale('pt-BR');
const localizadorDeMomentos = momentLocalizer(moment);

const FiltroEventos = ({ filtroDeEventos, setFiltroDeEventos, handleBuscarEventos, handleCriarEvento }) => {
  const podeCriarEvento = ValidarPermissao.validar("CriarEvento");
  return (
    <div className={style.filterContainer}>
      <div className={style.filterOptions}>
        <label>
          <input
            type="radio"
            value="todos"
            checked={filtroDeEventos === 'todos'}
            onChange={() => setFiltroDeEventos('todos')}
          />
          Todos
        </label>
        <label>
          <input
            type="radio"
            value="feriado"
            checked={filtroDeEventos === 'feriado'}
            onChange={() => setFiltroDeEventos('feriado')}
          />
          Feriados
        </label>
        <label>
          <input
            type="radio"
            value="evento"
            checked={filtroDeEventos === 'evento'}
            onChange={() => setFiltroDeEventos('evento')}
          />
          Eventos
        </label>
      </div>
      <div className={style.searchbarContainer}>
        <InputBuscar
          placeholder="Buscar por nome"
          onChange={handleBuscarEventos}
          maxLength={30}
        />
      </div>
      <div className={style.filterOptions}>
        {podeCriarEvento && <BotaoNovo link={handleCriarEvento} />} {/* Botão só aparece se tiver permissão */}
      </div>
    </div>
  );
};

const CustomToolbar = ({ label, onNavigate, onView }) => {
  const isMobile = window.innerWidth <= 768;

  return (
    <div className={style.toolbar}>
      {!isMobile && (
        <div className={style.navButtons}>
          <button onClick={() => onNavigate('PREV')}>Anterior</button>
          <button onClick={() => onNavigate('TODAY')}>Hoje</button>
          <button onClick={() => onNavigate('NEXT')}>Próximo</button>
        </div>
      )}
      <span className={style.label}>{label}</span>
      {!isMobile && (
        <div className={style.viewButtons}>
          <button onClick={() => onView('month')}>Mês</button>
          <button onClick={() => onView('week')}>Semana</button>
          <button onClick={() => onView('day')}>Dia</button>
          <button onClick={() => onView('agenda')}>Agenda</button>
        </div>
      )}
    </div>
  );
};

const ComponenteCalendario = () => {
  const [listaDeEventos, setListaDeEventos] = useState([]);
  const [filtroDeEventos, setFiltroDeEventos] = useState('todos');
  const [termoDeBusca, setTermoDeBusca] = useState('');
  const [dataAtualDoCalendario, setDataAtualDoCalendario] = useState(new Date());
  const [indiceDoEventoAtual, setIndiceDoEventoAtual] = useState(0);
  const [mostrarModalCriar, setMostrarModalCriar] = useState(false);
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
  const [eventoSelecionado, setEventoSelecionado] = useState(null);
  const [turmas, setTurmas] = useState([]);
  const [pessoas, setPessoas] = useState([]);
  const [novoEvento, setNovoEvento] = useState({
    titulo: '',
    descricao: '',
    dataInicio: '',
    dataFim: '',
    pessoaID: 0,
    ativo: true,
    turmaIDs: [],
    pessoaIDs: []
  });
  const [visualizacaoAtual, setVisualizacaoAtual] = useState('month'); // Default para desktop

  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState('');
  const [tipoAlerta, setTipoAlerta] = useState('');

  const [erroFeriados, setErroFeriados] = useState('');
  const [erroEventos, setErroEventos] = useState('');

  const [mostrarConfirmacaoExcluir, setMostrarConfirmacaoExcluir] = useState(false);
  const [eventoParaExcluir, setEventoParaExcluir] = useState(null);

  const [loading, setLoading] = useState(false);


  const confirmarExclusao = (eventoId) => {
    setEventoParaExcluir(eventoId);
    setMostrarConfirmacaoExcluir(true);
  };

  const exibirAlerta = (mensagem, tipo) => {
    setMensagemAlerta(mensagem);
    setTipoAlerta(tipo);
    setMostrarAlerta(true);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

  useEffect(() => {
    const anosParaBuscar = [2024, 2025, 2026, 2027, 2028];
    const promessasDeFeriados = anosParaBuscar.map(ano =>
      fetch(`https://brasilapi.com.br/api/feriados/v1/${ano}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Erro ao buscar feriados para o ano ${ano}: ${response.statusText}`);
          }
          return response.json();
        })
        .catch(error => {
          console.error('Erro ao buscar feriados:', error);
          setErroFeriados('Erro ao carregar feriados. Tente novamente mais tarde.');
          return []; // Retorna um array vazio em caso de erro
        })
    );

    Promise.all(promessasDeFeriados).then(resultados => {
      const feriados = resultados.flat().map(feriado => {
        if (!feriado.date || !feriado.name) {
          console.warn('Feriado inválido:', feriado);
          return null; // Ignora feriados inválidos
        }

        const dataInicio = new Date(feriado.date);
        dataInicio.setMinutes(dataInicio.getMinutes() + dataInicio.getTimezoneOffset()); // Corrige o deslocamento UTC

        return {
          title: feriado.name,
          start: dataInicio,
          end: dataInicio,
          allDay: true,
          type: 'feriado'
        };
      }).filter(Boolean); // Remove valores nulos

      setListaDeEventos(eventosAnteriores => {
        const eventosUnicos = [...eventosAnteriores];
        feriados.forEach(feriado => {
          const jaExiste = eventosUnicos.some(
            evento =>
              evento.type === 'feriado' &&
              evento.start.getTime() === feriado.start.getTime() &&
              evento.title === feriado.title
          );
          if (!jaExiste) {
            eventosUnicos.push(feriado);
          }
        });
        return eventosUnicos;
      });
    });
  }, []);

  useEffect(() => {
    EventoApi.listarEventosAsync()
      .then(eventos => {
        if (!Array.isArray(eventos)) {
          throw new Error('Resposta inválida da API de eventos');
        }

        const eventosFormatados = eventos.map(evento => ({
          id: evento.eventoID,
          title: evento.titulo,
          start: new Date(evento.dataInicio),
          end: new Date(evento.dataFim),
          allDay: false,
          type: 'evento',
          descricao: evento.descricao,
          pessoaID: evento.pessoaID,
          ativo: evento.ativo
        }));

        setListaDeEventos(eventosFormatados);
      })
      .catch(error => {
        console.error('Erro ao listar eventos:', error);
        setErroEventos('Erro ao carregar eventos. Tente novamente mais tarde.');
      });

    TurmaApi.ListarTurmaSemPaginacaoAsync()
      .then(setTurmas)
      .catch(error => {
        console.error('Erro ao listar turmas:', error);
      });

    PessoaTurmaApi.listarTodasPessoasAsync()
      .then(setPessoas)
      .catch(error => {
        console.error('Erro ao listar pessoas:', error);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setVisualizacaoAtual('agenda'); // Modo "agenda" para telas pequenas
      } else {
        setVisualizacaoAtual('month'); // Modo "mês" para telas maiores
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNavegarNoCalendario = (data) => {
    setDataAtualDoCalendario(data);
  };

  const handleBuscarEventos = (e) => {
    const termo = e.target.value;
    setTermoDeBusca(termo);
    const eventosCorrespondentes = listaDeEventos.filter(evento => evento.title.toLowerCase().includes(termo.toLowerCase()));
    if (eventosCorrespondentes.length > 0) {
      setIndiceDoEventoAtual(0);
      setDataAtualDoCalendario(eventosCorrespondentes[0].start);
    }
  };

  const handleCriarEvento = (e) => {
    e.preventDefault();
    setMostrarModalCriar(true);
  };

  const handleSalvarEvento = async () => {
    try {
      setLoading(true);
      const eventoCriado = await EventoApi.criarEventoAsync({
        Titulo: novoEvento.titulo,
        Descricao: novoEvento.descricao,
        DataInicio: novoEvento.dataInicio,
        DataFim: novoEvento.dataFim,
        Ativo: novoEvento.ativo
      });

      if (novoEvento.turmaIDs.length > 0) {
        await EventoApi.vincularEventoTurmasAsync({
          eventoID: eventoCriado.id,
          turmaIDs: novoEvento.turmaIDs
        });
      }

      if (novoEvento.pessoaIDs.length > 0) {
        await EventoApi.vincularEventoPessoasAsync({
          eventoID: eventoCriado.id,
          pessoaIDs: novoEvento.pessoaIDs
        });
      }

      setListaDeEventos((prevEventos) => [
        ...prevEventos,
        {
          title: eventoCriado.titulo,
          start: new Date(eventoCriado.dataInicio),
          end: new Date(eventoCriado.dataFim),
          allDay: false,
          type: 'evento'
        }
      ]);

      setMostrarModalCriar(false);
      setNovoEvento({
        titulo: '',
        descricao: '',
        dataInicio: '',
        dataFim: '',
        pessoaID: 0,
        ativo: true,
        turmaIDs: [],
        pessoaIDs: []
      });

      exibirAlerta('Evento criado com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao salvar evento:', error);
      exibirAlerta('Erro ao salvar evento. Tente novamente.', 'danger');
    } finally {
      setLoading(false);
    }
  };

  const handleSalvarEdicao = async (evento) => {
    try {
      setLoading(true)
      const payload = {
        EventoID: evento.id,
        Titulo: evento.title,
        Descricao: evento.descricao,
        DataInicio: evento.start.toISOString(),
        DataFim: evento.end.toISOString(),
        PessoaID: evento.pessoaID,
        Ativo: evento.ativo
      };


      await EventoApi.atualizarEventoAsync(payload);

      setListaDeEventos((prevEventos) =>
        prevEventos.map((e) =>
          e.id === evento.id
            ? {
              ...e,
              title: evento.title,
              descricao: evento.descricao,
              start: evento.start,
              end: evento.end,
            }
            : e
        )
      );

      setMostrarModalEditar(false);
      exibirAlerta('Evento atualizado com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao atualizar evento:', error);
      exibirAlerta('Erro ao atualizar evento. Tente novamente.', 'danger');
    } finally {
      setLoading(false);
    }
  };

  const handleExcluirEvento = async () => {
    try {
      setLoading(true);
      await EventoApi.excluirEventoAsync(eventoParaExcluir);
      setListaDeEventos((prevEventos) => prevEventos.filter((evento) => evento.id !== eventoParaExcluir));
      setMostrarConfirmacaoExcluir(false);
      setMostrarModalEditar(false);
      exibirAlerta('Evento excluído com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao excluir evento:', error);
      exibirAlerta('Erro ao excluir evento. Tente novamente.', 'danger');
    } finally {
      setLoading(false)
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNovoEvento({ ...novoEvento, [name]: value });
  };

  const handleVincularPessoas = async (eventoId, pessoaIDs) => {
    try {
      await EventoApi.vincularEventoPessoasAsync({ eventoID: eventoId, pessoaIDs });
    } catch (error) {
      console.error('Erro ao vincular pessoas:', error);
    }
  };

  const handleVincularTurmas = async (eventoId, turmaIDs) => {
    try {
      await EventoApi.vincularEventoTurmasAsync({ eventoID: eventoId, turmaIDs });
    } catch (error) {
      console.error('Erro ao vincular turmas:', error);
    }
  };

  const handleChangePessoas = (selectedOptions) => {
    const selectedPessoaIDs = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setNovoEvento((prev) => ({ ...prev, pessoaIDs: selectedPessoaIDs }));

    if (novoEvento.id) {
      handleVincularPessoas(novoEvento.id, selectedPessoaIDs);
    }
  };

  const handleChangeTurmas = (selectedOptions) => {
    const selectedTurmaIDs = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setNovoEvento((prev) => ({ ...prev, turmaIDs: selectedTurmaIDs }));

    if (novoEvento.id) {
      handleVincularTurmas(novoEvento.id, selectedTurmaIDs);
    }
  };

  const handleSelecionarEvento = (evento) => {
    setEventoSelecionado({
      id: evento.id,
      title: evento.title,
      descricao: evento.descricao,
      start: evento.start,
      end: evento.end,
      pessoaID: evento.pessoaID,
      ativo: evento.ativo,
      type: evento.type
    });
    setMostrarModalEditar(true);
  };

  const eventosFiltrados = listaDeEventos.filter(evento => {
    if (filtroDeEventos !== 'todos' && evento.type !== filtroDeEventos) {
      return false;
    }
    if (termoDeBusca && !evento.title.toLowerCase().includes(termoDeBusca.toLowerCase())) {
      return false;
    }
    return true;
  });

  const podeExcluirEvento = ValidarPermissao.validar("ExcluirEvento"); // ID da funcionalidade ExcluirEvento
  const podeEditarEvento = ValidarPermissao.validar("AtualizarEvento"); // ID da funcionalidade AtualizarEvento

  return (
    <div className={style.calendarContainer}>
      <Alerta
        tipo={tipoAlerta}
        mensagem={mensagemAlerta}
        visivel={mostrarAlerta}
        aoFechar={() => setMostrarAlerta(false)}
      />
      {loading && <Loader />}
      <FiltroEventos
        filtroDeEventos={filtroDeEventos}
        setFiltroDeEventos={setFiltroDeEventos}
        handleBuscarEventos={handleBuscarEventos}
        handleCriarEvento={handleCriarEvento}
      />
      <Calendar
        className={style.calendar}
        localizer={localizadorDeMomentos}
        events={eventosFiltrados}
        startAccessor="start"
        endAccessor="end"
        onNavigate={handleNavegarNoCalendario}
        onSelectEvent={handleSelecionarEvento}
        date={dataAtualDoCalendario}
        view={visualizacaoAtual}
        onView={(view) => setVisualizacaoAtual(view)}
        components={{
          toolbar: CustomToolbar,
        }}
        messages={{
          date: 'Data',
          time: 'Hora',
          event: 'Evento',
          allDay: 'Dia inteiro',
          week: 'Semana',
          day: 'Dia',
          month: 'Mês',
          previous: 'Anterior',
          next: 'Próximo',
          yesterday: 'Ontem',
          tomorrow: 'Amanhã',
          today: 'Hoje',
          agenda: 'Agenda',
          noEventsInRange: 'Não há eventos neste intervalo.',
          showMore: total => `+${total} mais`,
        }}
      />
      <Modal show={mostrarModalCriar} onHide={() => setMostrarModalCriar(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Criar Evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="titulo">
              <Form.Label>Título</Form.Label>
              <InputBuscar
                maxLength={100}
                type="text"
                name="titulo"
                value={novoEvento.titulo}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId="descricao">
              <Form.Label>Descrição</Form.Label>
              <InputBuscar
                maxLength={250}
                type="text"
                name="descricao"
                value={novoEvento.descricao}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId="dataInicio">
              <Form.Label>Data de Início</Form.Label>
              <InputBuscar
                onKeyDown={(e) => e.preventDefault()}
                min="1900-01-01"
                max="2099-12-31"
                type="datetime-local"
                name="dataInicio"
                value={novoEvento.dataInicio}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId="dataFim">
              <Form.Label>Data de Fim</Form.Label>
              <Form.Control
                min="1900-01-01"
                max="2099-12-31"
                onKeyDown={(e) => e.preventDefault()}
                type="datetime-local"
                name="dataFim"
                value={novoEvento.dataFim}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId="turmaIDs">
              <Form.Label>Turmas</Form.Label>
              <Select
                closeMenuOnSelect={false}
                isMulti
                options={turmas.map((turma) => ({ value: turma.id, label: turma.nome }))}
                value={turmas
                  .filter((turma) => novoEvento.turmaIDs.includes(turma.id))
                  .map((turma) => ({ value: turma.id, label: turma.nome }))}
                onChange={(selectedOptions) =>
                  setNovoEvento((prev) => ({
                    ...prev,
                    turmaIDs: selectedOptions ? selectedOptions.map((option) => option.value) : []
                  }))
                }
                placeholder="Selecione as turmas"
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </Form.Group>
            <Form.Group controlId="pessoaIDs">
              <Form.Label>Pessoas</Form.Label>
              <Select
                closeMenuOnSelect={false}
                isMulti
                options={pessoas.map((pessoa) => ({ value: pessoa.id, label: pessoa.nomeCompleto }))}
                value={pessoas
                  .filter((pessoa) => novoEvento.pessoaIDs.includes(pessoa.id))
                  .map((pessoa) => ({ value: pessoa.id, label: pessoa.nomeCompleto }))}
                onChange={(selectedOptions) =>
                  setNovoEvento((prev) => ({
                    ...prev,
                    pessoaIDs: selectedOptions ? selectedOptions.map((option) => option.value) : []
                  }))
                }
                placeholder="Selecione as pessoas"
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalCriar(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSalvarEvento}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={mostrarModalEditar} onHide={() => setMostrarModalEditar(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {eventoSelecionado?.type === 'feriado'
              ? 'Visualizar Feriado'
              : (podeEditarEvento ? 'Editar Evento' : 'Visualizar Evento')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="titulo">
              <Form.Label>Título</Form.Label>
              <Form.Control
                type="text"
                name="titulo"
                value={eventoSelecionado?.title || ''}
                readOnly={!podeEditarEvento || eventoSelecionado?.type === 'feriado'}
                onChange={(e) =>
                  podeEditarEvento && eventoSelecionado?.type !== 'feriado' &&
                  setEventoSelecionado((prev) => ({
                    ...prev,
                    title: e.target.value,
                  }))
                }
              />
            </Form.Group>
            <Form.Group controlId="descricao">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                type="text"
                name="descricao"
                value={eventoSelecionado?.descricao || ''}
                readOnly={!podeEditarEvento || eventoSelecionado?.type === 'feriado'}
                onChange={(e) =>
                  podeEditarEvento && eventoSelecionado?.type !== 'feriado' &&
                  setEventoSelecionado((prev) => ({
                    ...prev,
                    descricao: e.target.value,
                  }))
                }
              />
            </Form.Group>
            <Form.Group controlId="dataInicio">
              <Form.Label>Data de Início</Form.Label>
              <Form.Control
                type="datetime-local"
                name="dataInicio"
                value={eventoSelecionado?.start?.toISOString().slice(0, 16) || ''}
                readOnly={!podeEditarEvento || eventoSelecionado?.type === 'feriado'}
                onChange={(e) =>
                  podeEditarEvento && eventoSelecionado?.type !== 'feriado' &&
                  setEventoSelecionado((prev) => ({
                    ...prev,
                    start: new Date(e.target.value),
                  }))
                }
              />
            </Form.Group>
            <Form.Group controlId="dataFim">
              <Form.Label>Data de Fim</Form.Label>
              <Form.Control
                type="datetime-local"
                name="dataFim"
                value={eventoSelecionado?.end?.toISOString().slice(0, 16) || ''}
                readOnly={!podeEditarEvento || eventoSelecionado?.type === 'feriado'}
                onChange={(e) =>
                  podeEditarEvento && eventoSelecionado?.type !== 'feriado' &&
                  setEventoSelecionado((prev) => ({
                    ...prev,
                    end: new Date(e.target.value),
                  }))
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalEditar(false)}>
            Fechar
          </Button>
          {podeEditarEvento && eventoSelecionado?.type !== 'feriado' && (
            <Button variant="primary" onClick={() => handleSalvarEdicao(eventoSelecionado)}>
              Salvar
            </Button>
          )}
          {podeExcluirEvento && eventoSelecionado?.type !== 'feriado' && (
            <Button variant="danger" onClick={() => confirmarExclusao(eventoSelecionado.id)}>
              Excluir
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal show={mostrarConfirmacaoExcluir} onHide={() => setMostrarConfirmacaoExcluir(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza de que deseja excluir este evento? Esta ação não pode ser desfeita.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarConfirmacaoExcluir(false)}>
            Cancelar
          </Button>
          <BotaoComLoading variant="danger" onClick={handleExcluirEvento}>
            Excluir
          </BotaoComLoading>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ComponenteCalendario;